/* eslint-disable arrow-body-style */
import React from 'react';
import classNames from 'classnames';
import ADD from '@/pages/home/assets/svg/studio//opinions/add.svg';
import './index.scss';
import { useIntl } from 'umi';

interface IProps {
  className?: string;
  onClick:  () => void;
  showModal: boolean;
  clickEditAppendix: boolean;
  setClickAddAppendix: (value: boolean) => void;
}

export default function EditIcon(props: IProps) {
  const { className, onClick, showModal, clickEditAppendix,setClickAddAppendix } = props || {};
  const { formatMessage } = useIntl();

  return (
    <>
      <span 
        className={classNames('dbh-studio-appendix-edit', className, {
          'dbh-studio-appendix-edit-clicked': (showModal && !clickEditAppendix)
        })}
        onClick={(e) => {
          onClick?.(e); // 确保调用传入的 onClick 函数
          setClickAddAppendix(true);
        }}
      >
        <img
          src={ ADD }
          className="dbh-add-row-icon"
        />
        <span className="dbh-studio-appendix-edit-text">{formatMessage({ id: 'dbh_studio_add_appendix' })}</span>
      </span>
    </>
  );
}
